import jsPDF from "jspdf";
import html2canvas from "html2canvas";

class PDFGenerator {
  /**
   *
   * @param {*} options : jsPDF and html2canvas options
   * @param {*} htmlPagesElements
   */
  constructor(options, htmlPagesElements) {
    this.options = {
      jsPDF: {
        orientation: "p",
        unit: "mm",
        format: "letter",
        ...(options.jsPDF || {}),
      },
      html2canvas: {
        allowTaint: true,
        logging: false,
        scale: 2,
        x: 0,
        y: 0,
        ...(options.html2canvas || {}),
      },
    };
    this.doc = new jsPDF(this.options.jsPDF);
    this.width = this.doc.internal.pageSize.getWidth();
    this.height = this.doc.internal.pageSize.getHeight();
    this.progress = [];
    this.htmlPagesElements = htmlPagesElements;
    this.totalPages = htmlPagesElements.length;
  }

  /**
   * render HTML Element using html2canvas
   * @param {*} htmlElement
   * @param {*} callback : async function (progress, total, text)
   * @returns
   */
  async renderPage(htmlElement, callback) {
    const canvas = await html2canvas(htmlElement, this.options.html2canvas);
    this.progress.push(1);
    const page = this.progress.length;
    callback(page, this.totalPages, "Renderizando páginas...");
    return canvas;
  }

  /**
   * add pages to PDF document
   * @param {*} canvas : canvas element
   * @param {*} newPage: create new page or not
   */
  addPage(canvas, newPage) {
    if (newPage) {
      this.doc.addPage({
        format: this.options.jsPDF.format,
        orientation: this.options.jsPDF.orientation,
      });
    }
    this.doc.addImage(
      canvas.toDataURL("image/jpeg"),
      "JPEG",
      0,
      0,
      this.width,
      this.height
    );
  }

  /**
   * Parse HTML elements pages to PDF document using jsPDF and html2canvas
   * @param {*} callback : async function (page, totalPages, text)
   * @returns
   */
  async html2pdf(
    // eslint-disable-next-line no-unused-vars
    callback = (progress, total, text) => {}
  ) {
    const rendered = [];

    // pages rendering
    for (const htmlElement of this.htmlPagesElements) {
      rendered.push(await this.renderPage(htmlElement, callback));
    }

    // add rendered pages to document
    rendered.forEach((canvas, index) => {
      const page = index + 1;
      callback(page, this.totalPages, `Construyendo documento PDF...`);
      this.addPage(canvas, page > 1);
    });

    return this.doc;
  }
}

const PdfPrint = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.$html2pdf = (
      htmlPagesElements,
      options = { jsPDF: {}, html2canvas: {} },
      // eslint-disable-next-line no-unused-vars
      callback = (progress, total, text) => {}
    ) => new PDFGenerator(options, htmlPagesElements).html2pdf(callback);
  },
};

export default PdfPrint;
